import React, { useRef } from 'react'
import { ACCEPTED_FORMATS, BUTTON_TEXT } from './constants'
import { buttonStyles } from './styles'

interface Props {
  onFilesSelected: (files: File[]) => void
  isLoading: boolean
}

const UploadButton: React.FC<Props> = ({ onFilesSelected, isLoading }) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => inputRef.current?.click()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? [])
    if (files.length > 0) onFilesSelected(files)
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_FORMATS}
        onChange={handleChange}
        multiple
        style={{ display: 'none' }}
      />
      <button
        onClick={handleClick}
        disabled={isLoading}
        style={isLoading ? buttonStyles.loading : buttonStyles.default}
      >
        {isLoading ? BUTTON_TEXT.loading : BUTTON_TEXT.default}
      </button>
    </>
  )
}

export default UploadButton
